import type { SvgComponent } from '@/types/SvgComponent';

export const FolderEmptyIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_1102_656)">
        <path
          d="M8.81934 4.72217C9.07652 4.74777 9.3205 4.84852 9.52051 5.01221L9.61719 5.09912L12.2324 7.71533H20.25C20.5981 7.71533 20.9316 7.85396 21.1777 8.1001C21.4239 8.34624 21.5625 8.67974 21.5625 9.02783V19.6108C21.5625 19.9368 21.4326 20.2495 21.2021 20.48C20.9717 20.7105 20.659 20.8403 20.333 20.8403H3.69043C3.35843 20.8394 3.04043 20.7069 2.80566 20.4722C2.5709 20.2374 2.4384 19.9194 2.4375 19.5874V6.02783C2.4375 5.67973 2.57612 5.34624 2.82227 5.1001C3.06841 4.85396 3.4019 4.71533 3.75 4.71533H8.69043L8.81934 4.72217ZM3.5625 19.5845L3.57227 19.6343C3.5788 19.6501 3.58825 19.6649 3.60059 19.6772C3.62511 19.7018 3.65869 19.7152 3.69336 19.7153H20.333C20.3606 19.7153 20.3877 19.7046 20.4072 19.6851C20.4267 19.6655 20.4375 19.6384 20.4375 19.6108V9.02783C20.4375 8.9781 20.418 8.93018 20.3828 8.89502C20.3476 8.85986 20.2997 8.84033 20.25 8.84033H3.5625V19.5845ZM3.75 5.84033C3.70027 5.84033 3.65235 5.85986 3.61719 5.89502C3.58202 5.93018 3.5625 5.9781 3.5625 6.02783V7.71533H10.6426L8.82129 5.89502V5.89404C8.80386 5.87686 8.78295 5.86415 8.76074 5.85498L8.68945 5.84033H3.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1102_656">
          <rect width="24" height="24" fill="currentColor" transform="translate(0 0.777832)" />
        </clipPath>
      </defs>
    </svg>
  );
};
